import { schema } from 'normalizr';

const workCategory = new schema.Entity('workCategory');

export default workCategory;
